import * as AmplitudeBrowser from "@amplitude/analytics-browser";
import uuidv4 from "uuid/v4";
import config from "../../config";

export default class AnalyticsEventTrackerWeb {
  static localStorageKey = "REGISTRATION_INFO";

  static trackPaymentConversion(params) {
    const amountNumber = Number(params.amount);
    const transactionId = uuidv4();

    if (config.trackEvents) {
      window.dataLayer = window.dataLayer || [];

      window.lastPurchaseValue = amountNumber;

      // Old Analytics
      window.dataLayer.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: transactionId,
              affiliation: "",
              revenue: amountNumber.toString(),
              tax: (
                Math.round((amountNumber - amountNumber / 1.23) * 100) / 100
              ).toString(),
              shipping: 0,
              coupon: 0
            },
            products: [
              {
                name: "Squaber subscription",
                id: params.id.toString(),
                price: amountNumber.toString(),
                brand: "",
                category: "",
                variant: "",
                quantity: 1,
                coupon: ""
              }
            ]
          }
        }
      });

      // New analytics
      window.dataLayer.push({
        event: "purchase",
        transactions_id: transactionId,
        product_id: params.id.toString(),
        value: amountNumber.toString(),
        tax: (
          Math.round((amountNumber - amountNumber / 1.23) * 100) / 100
        ).toString(),
        currency: "PLN",
        items: "1"
      });
    }
  }

  static trackRegisterConversion(registerSource, userId, registrationMethod) {
    const conversionData = {
      event: "Registration",
      registerSource,
      userId
    };

    window.localStorage.setItem(
      this.localStorageKey,
      JSON.stringify(conversionData)
    );

    if (config.trackEvents) {
      if ("ga" in window) {
        const tracker = window.ga.getAll()[0];
        if (tracker) {
          tracker.send("event", "Registration", registerSource);
        }
      }
    }

    AmplitudeBrowser.setUserId(String(userId));
  }

  static attemptTrackRegisterConversionUsingGTM() {
    const conversionData = JSON.parse(
      window.localStorage.getItem(this.localStorageKey)
    );

    if (conversionData) {
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: "Registration",
        registerSource: conversionData.registerSource,
        user_id: conversionData.userId
      });

      window.localStorage.removeItem(this.localStorageKey);
    }
  }

  static trackUserLogInEvent() {
    AmplitudeBrowser.track("log_in");
  }

  static trackOfferModalEvent(id = null) {
    const type = id === null ? "premium_modal" : "marketing_message";

    AmplitudeBrowser.track("offer_modal", {
      marketing_message_id: id,
      type
    });
  }

  static trackRegistrationModalEvent(trigger) {
    AmplitudeBrowser.track("registration_modal", {
      trigger
    });
  }

  static trackPortfolioCreatedEvent() {
    AmplitudeBrowser.track("portfolio_created");
  }

  static trackPortfolioTransactionEvent() {
    AmplitudeBrowser.track("portfolio_transaction");
  }

  static trackStockAlertOnEvent(type, market, name) {
    AmplitudeBrowser.track("stock_alert_on", {
      type,
      market,
      name
    });
  }

  static trackTagCreatedEvent() {
    AmplitudeBrowser.track("tag_created");
  }

  static trackSearchListStockOnClickEvent({
    searchListName,
    market,
    ticker,
    searchListPosition
  }) {
    AmplitudeBrowser.track("search_list_stock_click", {
      search_list_name: searchListName,
      market,
      ticker,
      position: searchListPosition
    });
  }

  static trackSearchResultOnClickEvent({ market, ticker }) {
    AmplitudeBrowser.track("user_search_click", {
      market,
      ticker
    });
  }

  static trackSearchPageShownEvent() {
    AmplitudeBrowser.track("search_click");
  }
}
